import React from 'react';
import Niit from './niit';

const PageList = () => <Niit />;

export default PageList;
